import { Airport } from "../../../models/airport";
import "./index.css";
import { Tooltip } from "react-tooltip";
import { Text, VStack, HStack } from "@chakra-ui/react";
import { roundDistance } from "@/utils/airport_distance";
import { t } from "i18next";

interface AirportMarkerProps {
  airport: Airport;
  state?: "default" | "cold" | "warm" | "hot" | "origin" | "destination";
  distance?: number;
}

function AirportMarker({
  airport,
  state = "default",
  distance,
}: AirportMarkerProps) {
  return (
    <>
      <div
        className={`airport-marker ${state}`}
        data-tooltip-id={`airport-tooltip-${airport.id}`}
      ></div>
      <Tooltip
        id={`airport-tooltip-${airport.id}`}
        render={() => (
          <VStack align="center" gap={0.5}>
            <HStack gap={1}>
              <Text fontSize="12px" fontWeight={600} color="white">
                {airport.name}
              </Text>
              <Text fontSize="10px" color="gray.300">
                ({airport.iata})
              </Text>
            </HStack>
            {distance && (
              <Text fontSize="10px" color="gray.400" mt={-1}>
                {t("game.distance.distanceAway", {
                  distance: roundDistance(distance),
                })}
              </Text>
            )}
          </VStack>
        )}
      />
    </>
  );
}

export default AirportMarker;
